var domain_backend = window.location.origin + "/api";

export { domain_backend }